import { useEffect, useState } from "react";
import api from "@/lib/api";
import Reveal from "@/components/Reveal";
import GoldParticles from "@/components/GoldParticles";

export default function Schedule() {
  const [days, setDays] = useState([]);
  const [active, setActive] = useState(0);

  useEffect(() => {
    api.get("/schedule").then((r) => setDays(r.data)).catch(() => {});
  }, []);

  const day = days[active];

  return (
    <div data-testid="schedule-page">
      <section className="relative overflow-hidden border-b border-white/5 py-24 sm:py-28">
        <GoldParticles density={30} />
        <div className="relative z-10 mx-auto max-w-7xl px-5 sm:px-8">
          <Reveal>
            <p className="eyebrow mb-5">The Programme</p>
            <h1 data-testid="schedule-heading" className="max-w-3xl font-display text-4xl sm:text-5xl lg:text-6xl font-black leading-[1.05] tracking-tight text-[#F6F4EE]">
              Every Hour,<br />
              <span className="text-gold-sheen">Accounted For.</span>
            </h1>
            <p className="mt-7 max-w-2xl text-sm sm:text-base leading-relaxed text-[#A19E95]">
              Friday deals the opening hand; Saturday crowns the table. All sessions are held across the Pune
              Lavasa campus.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-10 flex flex-wrap gap-3" data-testid="schedule-day-tabs">
              {days.map((d, i) => (
                <button
                  key={d.id}
                  data-testid={`schedule-day-tab-${i}`}
                  onClick={() => setActive(i)}
                  className={`border px-6 py-3 text-[11px] uppercase tracking-[0.2em] transition-all duration-300 ${
                    active === i
                      ? "border-[#D4AF37] bg-[#D4AF37] text-[#08080A]"
                      : "border-white/15 text-[#A19E95] hover:border-[#D4AF37]/50 hover:text-[#F6F4EE]"
                  }`}
                >
                  Day {i + 1}
                </button>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      {day && (
        <section className="mx-auto max-w-5xl px-5 sm:px-8 py-20 sm:py-24" data-testid="schedule-timeline">
          <Reveal key={day.id}>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#B39343]">{day.day}</p>
            <h2 className="mt-3 font-display text-2xl sm:text-3xl font-bold text-[#F6F4EE]">{day.theme}</h2>
          </Reveal>
          <div className="mt-12 flex flex-col">
            {day.slots.map((slot, i) => (
              <Reveal key={`${day.id}-${i}`} delay={i * 0.05}>
                <div data-testid={`schedule-slot-${i}`} className="group flex gap-6 sm:gap-10 border-l border-[#D4AF37]/25 pb-10 pl-8 sm:pl-12 last:pb-0 relative">
                  <span className="absolute -left-[5px] top-1 h-2.5 w-2.5 rounded-full bg-[#D4AF37] transition-transform duration-300 group-hover:scale-150" aria-hidden="true" />
                  <span className="w-24 shrink-0 font-mono text-sm text-[#E5C97A]">{slot.time}</span>
                  <div>
                    <h3 className="font-display text-lg sm:text-xl font-semibold text-[#F6F4EE]">{slot.title}</h3>
                    <p className="mt-1.5 text-xs uppercase tracking-[0.18em] text-[#6E6B63]">{slot.location}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
